import { Link } from "react-router-dom";
import { cn } from "@nexus/ui";

export function ResourceTabs({
  label,
  value,
  items,
}: {
  label: string;
  value: string;
  items: readonly { value: string; label: string; to: string }[];
}) {
  return (
    <nav aria-label={label} className="mb-4 flex gap-5 border-b border-border">
      {items.map((item) => (
        <Link
          key={item.value}
          to={item.to}
          aria-current={value === item.value ? "page" : undefined}
          className={cn(
            "border-b-2 px-1 py-2 text-sm font-medium focus-visible:outline-2 focus-visible:outline-focus",
            value === item.value
              ? "border-interaction-text text-primary"
              : "border-transparent text-muted hover:text-primary",
          )}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
